import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Router } from '@angular/router';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { Observable, of, filter, map, switchMap } from 'rxjs';
import { DeregisterKkmSignatureForm } from '../deregister-kkm.model';
import { Tariff } from '../../../../tariffs/tariff.model';
import { CertificateModalSignatureData } from '../../../../../shared/services/signature-nca-common-utils.service';
import { BpService } from '../../../../../core/services/bp.service';
import { ModalService } from '../../../../../core/modal/modal.service';
import { TariffService } from '../../../../../core/services/tariff.service';
import { UsersService } from '../../../../users/user.service';
import { ConfirmBySmsComponent } from '../../../../../shared/components/modals/confirm-by-sms/confirm-by-sms.component';
import { KkmsDetailsService } from '../../../../../core/services/kkm-details.service';
import { KkmsApiService } from '../../../../../core/modules/kkms/kkms-api.service';
import { KkmAvailableOperations } from '../../../../../core/modules/kkms/kkms.types';
import { OrganizationApiService } from '../../../../../core/modules/organization/organization-api.service';
import { IKkm } from '../../../../../core/modules/retail-places/retail-paces.types';

@UntilDestroy()
@Component({
  selector: 'tax-deregister-kkm-sign',
  templateUrl: 'deregister-kkm-sign.component.html',
  styleUrls: ['deregister-kkm-sign.component.sass'],
})

export class DeregisterKkmSignComponent {
  @Input() set bpForm(kkmForm: DeregisterKkmSignatureForm) {
    this.deregisterReason$ = this.kkmsApiService.fetchDelReason(kkmForm.fields.kkmDelReason);
    this.kkmForm = kkmForm;
    this.selectedTariff$ = this.kkmsDetailsService.getKkm(Number(kkmForm.fields.kkmId))
      .pipe(
        switchMap((kkm: IKkm & KkmAvailableOperations) => (kkm.tariffId
          ? this.tariffService.getTariffById(kkm.tariffId)
          : of(undefined))),
      );
  }

  @Output() goBack: EventEmitter<void> = new EventEmitter<void>();

  data$: Observable<CertificateModalSignatureData> = this.kkmsApiService.fetchKkmRegistrationDocument(this.bpService.getProcessIds().pid)
    .pipe(
      map(document => ({
        doc: {
          signature: document,
        },
        type: 'SIGN',
      })),
    );

  deregisterReason$?: Observable<string>;
  kkmForm?: DeregisterKkmSignatureForm;
  oked$: Observable<any> = this.organizationApiService.fetchOrganization()
    .pipe(map(organization => organization.okved));

  selectedTariff$?: Observable<Tariff | undefined>;

  constructor(
    private router: Router,
    private kkmsDetailsService: KkmsDetailsService,
    private kkmsApiService: KkmsApiService,
    private bpService: BpService,
    private modalService: ModalService,
    private organizationApiService: OrganizationApiService,
    private tariffService: TariffService,
    private usersService: UsersService,
  ) { }

  back(): void {
    this.goBack.emit();
  }

  setSignature(modalData: CertificateModalSignatureData, kkmForm: DeregisterKkmSignatureForm): void {
    // @ts-ignore
    kkmForm.fields.signature = modalData.signature.signature;

    const { pid, tid } = this.bpService.getProcessIds();
    this.bpService.submit(pid, tid, kkmForm.fields)
      .pipe(untilDestroyed(this))
      .subscribe({
        next: () => {
          this.router.navigate(['main/kkms']);
        },
      });
  }

  signBySms(): void {
    this.usersService.getCurrentUserInfo()
      .pipe(
        switchMap(userInfo => this.modalService
          .openOld(ConfirmBySmsComponent, {
            title: 'sign.by.sms.title',
            buttonText: 'button.sign',
            businessProcessData: {
              IIN: userInfo.organisation.inn,
            },
            businessProcessMessage: 'inisSignBySmsMessage',
          })),
        filter(isSuccess => isSuccess),
        untilDestroyed(this),
      )
      .subscribe({
        next: () => {
          this.router.navigate(['main/kkms']);
        },
      });
  }
}
